package com.eladfinish.bible.contest.screens.main.ui.dialogs

import androidx.compose.material3.AlertDialog
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.ads.AdFreeReward
import com.eladfinish.bible.contest.not_now
import com.eladfinish.bible.contest.purchase_remove_ads
import com.eladfinish.bible.contest.purchase_upsell
import com.eladfinish.bible.contest.reward_earned_success
import com.eladfinish.bible.contest.screens.main.MainScreenAction
import com.eladfinish.bible.contest.screens.main.RemoveAdsSource
import dev.icerock.moko.resources.compose.stringResource

@Composable
internal fun RewardEarnedUpsellDialog(
    onAction: (MainScreenAction) -> Unit,
) {
    AlertDialog(
        onDismissRequest = { onAction(MainScreenAction.HideDialog) },
        title = {
            Text(
                text = stringResource(SharedRes.strings.reward_earned_success, AdFreeReward.MINUTES),
                style = MaterialTheme.typography.titleLarge,
            )
        },
        text = {
            Text(
                text = stringResource(SharedRes.strings.purchase_upsell),
                style = MaterialTheme.typography.bodyLarge.copy(
                    fontSize = 18.sp
                )
            )
        },
        confirmButton = {
            TextButton(
                onClick = {
                    onAction(MainScreenAction.RemoveAdsClicked(source = RemoveAdsSource.REWARD_UPSELL))
                }
            ) {
                Text(text = stringResource(SharedRes.strings.purchase_remove_ads))
            }
        },
        dismissButton = {
            TextButton(
                onClick = { onAction(MainScreenAction.HideDialog) }
            ) {
                Text(text = stringResource(SharedRes.strings.not_now))
            }
        }
    )
}

@Preview
@Composable
private fun RewardEarnedUpsellDialogPreview() {
    RewardEarnedUpsellDialog(onAction = {})
}
